import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UserHelperComponent } from '../user-helper/user-helper.component';
import { TaskService } from '../../services/task.service';
import { UserService } from '../../services/user.service';
import { NotifyService } from '@farris/ui-notify';
import { I18nService } from '../../services/i18n.service';

@Component({
  selector: 'wf-task-signadd',
  templateUrl: '../user-helper/user-helper.component.html',
  styleUrls: ['./task-signadd.component.css']
})
export class TaskSignaddComponent extends UserHelperComponent implements OnInit {

  @Input()
  public set addsign_context(context: any) {
    this.selectedUsers = [];
    this.addSignContext = { ...context, assignees: [] };
    this.showModal(!!this.addSignContext.workItemId);
  }
  @Output()
  completed = new EventEmitter<any>();

  // 执行加签上下文参数
  addSignContext: {
    workItemId: string,
    action: 'AddSignFront' | 'AddSignBehind',
    assignees: string[],
    comment: ''// TODO: 加签日志
  };
  constructor(
    private taskSvc: TaskService,
    protected userSvc: UserService,
    protected notify: NotifyService,
    protected i18nService: I18nService
  ) {
    super(i18nService, userSvc);
    this.paginationOptions.id = 'WF-SignAdd-DataTable-Pagination';
  }

  ngOnInit() {
  }

  handleOk(): void {
    this.selectedUsers = this.userTable.selections;
    // 征询
    if (this.addSignContext.action === 'AddSignFront') {
      // 需要校验选中用户
      if (!this.selectedUsers || this.selectedUsers.length < 1) {
        this.notify.info(this.i18nService.getValue('static.addsign.selectConsultant'));
        return;
      }
      this.addSignContext.assignees = this.selectedUsers.map(user => user.ID);
      this.taskSvc.addSign(this.addSignContext).subscribe(() => {
        this.notify.success(this.i18nService.getValue('static.addsign.successConsult'));
        this.completed.emit(true);
        this.showModal(false);
      }, error => {
        if(error && error.error && error.error.Message) {
          this.notify.error(error.error.Message);
        }
      });
    } else {
      // 加签
      this.completed.emit(true);
      this.showModal(false);
    }
  }

}
